<ngx-spinner bdColor="rgba(0,0,0,0.5)" size="large" color="#ff5500" type="ball-spin-clockwise"
  template="<img style='height:50px;' src='assets/images/loading.gif' />">
  <p class="message" aria-live="polite">Please Wait ...</p>
</ngx-spinner>

<router-outlet></router-outlet>